import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { PrecosClient } from "@/client/modules/cirurgias/precos/precos-client";

export const Route = createFileRoute("/app/cirurgias/precos")({
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("cirurgias", "precosPage", {})),
  head: () => pageHead("Tabela de Preços"),
  component: PrecosPage,
});

function PrecosPage() {
  const { data } = useApiSuspenseQuery("cirurgias", "precosPage", {});
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Tabela de Preços" description="Valores de referência por procedimento cirúrgico." />
      <PrecosClient precos={data.precos} isAdmin={data.isAdmin} />
    </div>
  );
}
